/***
 *
 * 防止多重点击重复提交
 */
export default {
  install(Vue) {
    // 防重复点击(指令实现)
    Vue.directive('preventReClick', {
      inserted(el, binding) {
        // console.log(el, binding)
        function clickHandler() {
          if (!el.disabled) {
            el.disabled = true
            setTimeout(() => {
              el.disabled = false
            }, binding.value || 3000)
          }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__clickHandler__ = clickHandler
        el.addEventListener('click', clickHandler)
      },
      unbind(el) {
        // 解除事件监听
        el.removeEventListener('click', el.__clickHandler__)
        delete el.__vueClickOutside__
      },
    })
  },
}
